import * as types from './mutation-types'
import getters from './getters'
import fun from '../utils/function'

const state = {
  headerStatus:true,
  userInfo: null, // 用户信息
  userPermissions: [], // 用户权限列表
  permissionMap: {} // 权限映射表（便于快速查询）
};

const mutations = {
  [types.SHOW_HEADER](state) {
    state.headerStatus = true;
  },
  [types.HIDE_HEADER](state) {
    state.headerStatus = false;
  },
  [types.SET_USER_INFO](state, userInfo) {
    state.userInfo = userInfo;
    // 持久化到localStorage
    if (userInfo) {
      fun.setLocalStorage('userInfo', userInfo);
    }
  },
  [types.SET_USER_PERMISSIONS](state, permissions) {
    state.userPermissions = permissions;
    // 构建权限映射表
    const permissionMap = {};
    const buildMap = (list) => {
      if (!list || !list.length) return;
      list.forEach(item => {
        // 只有checked为true的权限才加入映射表
        if (item.path && item.checked === true) {
          permissionMap[item.path] = true;
        }
        // 递归处理子权限（后端返回的是list字段）
        if (item.list && item.list.length) {
          buildMap(item.list);
        }
      });
    };
    buildMap(permissions);
    state.permissionMap = permissionMap;
    // 持久化到localStorage（只存储permissions，permissionMap可从其计算得出）
    fun.setLocalStorage('userPermissions', permissions);
  },
  [types.CLEAR_USER_DATA](state) {
    state.userInfo = null;
    state.userPermissions = [];
    state.permissionMap = {};
    fun.removeLocalStorage('userInfo');
    fun.removeLocalStorage('userPermissions');
  }
};

export default {
  state,
  mutations,
  getters
}


// WEBPACK FOOTER //
// ./src/store/mutations.js